<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="400px"
    :title="$l('dialog_title_update_inv') || '批量更新库位'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <div>
      <el-form
        ref="form"
        size="small"
        :model="formData"
        label-position="top"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_in_location_no') || '更新库位编号'"
              prop="inLocationNo"
            >
              <el-input
                v-model.trim="formData.inLocationNo"
                :placeholder="
                  $l('placeholder_input_location_no') || '请输入目标库位'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="color: #C0C4CC; font-size: 13px;" class="mt-2">
        {{ $l('tips_update_ts') || '提示' }}：{{
          $l('tips_update_desc') ||
            '您选择的产品, 当前所在的库位, 将批量更新为您所输入的目标库位'
        }}
      </div>
    </div>
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      rules: {
        inLocationNo: [
          {
            required: true,
            message: this.$l('rules_message_location_no') || '请输入目标库位',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    async confirm() {
      const res = await validate.formValidate([this.$refs.form])
      if (!res) return
      this.$emit('confirm', this.formData)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
